import React from 'react';

const Header = ({ category, title, description, subtitle }) => (
  <div className="mb-6">
    <p className="text-xs font-semibold uppercase tracking-wider text-indigo-600 dark:text-indigo-400 mb-1">{category}</p>
    <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
      {title}
    </h2>
    {(subtitle || description) && (
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 max-w-2xl font-normal leading-relaxed">
        {subtitle || description}
      </p>
    )}
  </div>
);

export default Header;
